import { create } from "zustand"

import {
  ALLOWED_PARTNERS,
  DEFAULT_PARTNER,
  PARTNER_DATA,
  type AllowedPartner,
  type PartnerData,
} from "@/constants/partner"

interface State {
  // value should be in allowedPartners
  partner_identifier: AllowedPartner | null
}

interface Actions {
  setPartnerIdentifier: (
    partner_identifier: State["partner_identifier"]
  ) => void
  getPartnerData: () => PartnerData
  isPartnerAllowed: (partner_identifier: string) => boolean
}

const initialState: State = {
  partner_identifier: null,
}

const usePartnerInfo = create<State & Actions>()((set, get) => ({
  ...initialState,
  setPartnerIdentifier: (partner_identifier) => {
    if (!partner_identifier) return
    set({ partner_identifier })
    localStorage.setItem("partner_identifier", partner_identifier)
  },
  getPartnerData: () => {
    return PARTNER_DATA[get().partner_identifier || DEFAULT_PARTNER]
  },
  isPartnerAllowed: (partner_identifier) =>
    (ALLOWED_PARTNERS as readonly string[]).includes(partner_identifier),
}))

export { usePartnerInfo }
